<template>
  <div>
    <Menu />
    <pulse-loader
      :loading="loading"
      :color="color"
      :size="size"
      class="vue-loader"
    ></pulse-loader>
    <div
      class="container main"
      v-if="id_funcao == 2 || id_funcao == 1 || id_funcao == 7"
    >
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Gerenciar permissões"
            description="Selecione quais páginas devem estar visíveis para os usuários"
            url="/administracao"
            modalDocument="DocGerenciarPermissoes"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="accordion" role="tablist" id="accordion-permissions">
            <PermissionAccordion
              title="Agente Comunitário de Saúde"
              accordion-id="accordion-1"
              accordion-group="my-accordion-1"
              :pages="pagesCategoryAcs"
              :permissionsData="permissoesAcsData"
              :permissions="permissoesAcs"
              :onSave="salvarPermissoes"
              :roleId="3"
              :loading="loading"
            />
            <PermissionAccordion
              title="Aux/Téc Enfermagem"
              accordion-id="accordion-2"
              accordion-group="my-accordion-2"
              :pages="pagesCategoryAuxEnfermagem"
              :permissionsData="permissoesAuxEnfermagemData"
              :permissions="permissoesAuxEnfermagem"
              :onSave="salvarPermissoes"
              :roleId="6"
              :loading="loading"
            />
            <PermissionAccordion
              title="Enfermeiro(a) / Médico(a)"
              accordion-id="accordion-3"
              accordion-group="my-accordion-3"
              :pages="pagesCategoryEnfermeiroMedico"
              :permissionsData="permissoesEnfermeiroMedicoData"
              :permissions="permissoesEnfermeiroMedico"
              :onSave="salvarPermissoes"
              :roleId="4"
              :loading="loading"
            />
            <PermissionAccordion
              title="Odontólogo(a)"
              accordion-id="accordion-4"
              accordion-group="my-accordion-4"
              :pages="pagesCategoryOdontologo"
              :permissionsData="permissoesOdontologoData"
              :permissions="permissoesOdontologo"
              :onSave="salvarPermissoes"
              :roleId="8"
              :loading="loading"
            />
            <PermissionAccordion
              title="Recepcionista"
              accordion-id="accordion-5"
              accordion-group="my-accordion-5"
              :pages="pagesCategoryRecepcionista"
              :permissionsData="permissoesRecepcionistaData"
              :permissions="permissoesRecepcionista"
              :onSave="salvarPermissoes"
              :roleId="5"
              :loading="loading"
            />
            <PermissionAccordion
              title="Gerente/Coordenador(a)"
              accordion-id="accordion-6"
              accordion-group="my-accordion-6"
              :pages="pagesCategoryCoordenador"
              :permissionsData="permissoesCoordenadorData"
              :permissions="permissoesCoordenador"
              :onSave="salvarPermissoes"
              :roleId="7"
              :loading="loading"
            />
            <PermissionAccordion
              title="Vacinador(a)"
              accordion-id="accordion-7"
              accordion-group="my-accordion-7"
              :pages="pagesCategoryVacinador"
              :permissionsData="permissoesVacinadorData"
              :permissions="permissoesVacinador"
              :onSave="salvarPermissoes"
              :roleId="13"
              :loading="loading"
            />
            <PermissionAccordion
              title="Téc. Aux de Saúde Bucal"
              accordion-id="accordion-8"
              accordion-group="my-accordion-8"
              :pages="pagesCategoryTecSaudeBucal"
              :permissionsData="permissoesTecSaudeBucalData"
              :permissions="permissoesTecSaudeBucal"
              :onSave="salvarPermissoes"
              :roleId="14"
              :loading="loading"
            />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import { permissoes } from '@/services/Permissoes.js'
import utils from '@/mixins/utils.js'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { mapState } from 'vuex'
import PermissionAccordion from './components/PermissionAccordion.vue'

const permissionKeysByProfile = {
  acs: [
    'dashboard',
    'gestao_cadastros',
    'visitas_domiciliares',
    'imunizacao',
    'vacina_idade_certa',
    'indicadores_aps',
    'pre_natal',
    'doencas_cronicas',
    'desempenho_por_equipe',
    'divergencia_vacinas',
    'saude_crianca',
    'vinculo_acompanhamento',
    'esf_eap',
    'saude_bucal',
    'emulti',
  ],
  auxEnfermagem: [
    'dashboard',
    'gestao_cadastros',
    'imunizacao',
    'vacina_idade_certa',
    'divergencia_vacinas',
    'indicadores_aps',
    'pre_natal',
    'doencas_cronicas',
    'desempenho_por_equipe',
    'saude_crianca',
    'vinculo_acompanhamento',
    'esf_eap',
    'indicadores_esb',
    'emulti',
    'saude_bucal',
  ],
  enfermeiroMedico: [
    'dashboard',
    'gestao_cadastros',
    'imunizacao',
    'vacina_idade_certa',
    'divergencia_vacinas',
    'indicadores_aps',
    'pre_natal',
    'doencas_cronicas',
    'desempenho_por_equipe',
    'saude_crianca',
    'vinculo_acompanhamento',
    'esf_eap',
    'indicadores_esb',
    'emulti',
    'saude_bucal',
  ],
  odontologo: [
    'dashboard',
    'gestao_cadastros',
    'indicadores_aps',
    'pre_natal',
    'doencas_cronicas',
    'desempenho_por_equipe',
    'vinculo_acompanhamento',
    'esf_eap',
    'indicadores_esb',
    'emulti',
    'saude_bucal',
  ],
  recepcionista: [
    'dashboard',
    'gestao_cadastros',
    'indicadores_aps',
    'pre_natal',
    'doencas_cronicas',
    'desempenho_por_equipe',
    'vinculo_acompanhamento',
    'esf_eap',
    'indicadores_esb',
    'emulti',
    'saude_bucal',
  ],
  coordenador: [
    'dashboard',
    'gestao_cadastros',
    'visitas_domiciliares',
    'imunizacao',
    'vacina_idade_certa',
    'indicadores_aps',
    'pre_natal',
    'doencas_cronicas',
    'desempenho_por_equipe',
    'divergencia_vacinas',
    'saude_crianca',
    'vinculo_acompanhamento',
    'producao',
    'bpa_e_ras',
    'esf_eap',
    'indicadores_esb',
    'emulti',
    'saude_bucal',
  ],
  vacinador: [
    'dashboard',
    'gestao_cadastros',
    'imunizacao',
    'vacina_idade_certa',
    'indicadores_aps',
    'divergencia_vacinas',
    'esf_eap',
    'indicadores_esb',
    'emulti',
    'saude_bucal',
  ],
  tecSaudeBucal: [
    'dashboard',
    'indicadores_aps',
    'vinculo_acompanhamento',
    'esf_eap',
    'indicadores_esb',
    'emulti',
    'saude_bucal',
  ],
}

function generateEmptyPermissions(keys) {
  return keys.reduce((acc, key) => {
    acc[key] = []
    return acc
  }, {})
}

export default {
  metaInfo: {
    title: 'Gerenciar permissões',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    PulseLoader,
    PermissionAccordion,
  },
  mixins: [utils],
  data() {
    return {
      permissoesAcsData: generateEmptyPermissions(permissionKeysByProfile.acs),
      permissoesAcs: generateEmptyPermissions(permissionKeysByProfile.acs),

      permissoesAuxEnfermagemData: generateEmptyPermissions(
        permissionKeysByProfile.auxEnfermagem
      ),
      permissoesAuxEnfermagem: generateEmptyPermissions(
        permissionKeysByProfile.auxEnfermagem
      ),

      permissoesEnfermeiroMedicoData: generateEmptyPermissions(
        permissionKeysByProfile.enfermeiroMedico
      ),
      permissoesEnfermeiroMedico: generateEmptyPermissions(
        permissionKeysByProfile.enfermeiroMedico
      ),

      permissoesOdontologoData: generateEmptyPermissions(
        permissionKeysByProfile.odontologo
      ),
      permissoesOdontologo: generateEmptyPermissions(
        permissionKeysByProfile.odontologo
      ),

      permissoesRecepcionistaData: generateEmptyPermissions(
        permissionKeysByProfile.recepcionista
      ),
      permissoesRecepcionista: generateEmptyPermissions(
        permissionKeysByProfile.recepcionista
      ),

      permissoesCoordenadorData: generateEmptyPermissions(
        permissionKeysByProfile.coordenador
      ),
      permissoesCoordenador: generateEmptyPermissions(
        permissionKeysByProfile.coordenador
      ),

      permissoesVacinadorData: generateEmptyPermissions(
        permissionKeysByProfile.vacinador
      ),
      permissoesVacinador: generateEmptyPermissions(
        permissionKeysByProfile.vacinador
      ),

      permissoesTecSaudeBucalData: generateEmptyPermissions(
        permissionKeysByProfile.tecSaudeBucal
      ),
      permissoesTecSaudeBucal: generateEmptyPermissions(
        permissionKeysByProfile.tecSaudeBucal
      ),
      pagesCategoryAcs: [
        { key: 'dashboard', value: 'Página inicial' },
        { key: 'gestao_cadastros', value: 'Gestão cadastros' },
        { key: 'visitas_domiciliares', value: 'Visitas domiciliares' },
        { key: 'imunizacao', value: 'Imunização' },
        { key: 'vacina_idade_certa', value: 'Vacina idade certa' },
        { key: 'indicadores_aps', value: 'Indicadores APS' },
        { key: 'esf_eap', value: 'eSF / eAP' },
        { key: 'emulti', value: 'eMulti' },
        { key: 'saude_bucal', value: 'eSB' },
        { key: 'pre_natal', value: 'Pré-natal' },
        { key: 'doencas_cronicas', value: 'Doenças crônicas' },
        { key: 'desempenho_por_equipe', value: 'Desempenho por equipe' },
        { key: 'saude_crianca', value: 'Saúde criança' },
        { key: 'vinculo_acompanhamento', value: 'Vínculo e Acompanhamento' },
      ],
      pagesCategoryAuxEnfermagem: [
        { key: 'dashboard', value: 'Página inicial' },
        { key: 'gestao_cadastros', value: 'Gestão cadastros' },
        { key: 'imunizacao', value: 'Imunização' },
        { key: 'vacina_idade_certa', value: 'Vacina idade certa' },
        { key: 'divergencia_vacinas', value: 'Divergência vacinas' },
        { key: 'indicadores_aps', value: 'Indicadores APS' },
        { key: 'esf_eap', value: 'eSF / eAP' },
        { key: 'emulti', value: 'eMulti' },
        { key: 'saude_bucal', value: 'eSB' },
        { key: 'pre_natal', value: 'Pré-natal' },
        { key: 'doencas_cronicas', value: 'Doenças crônicas' },
        { key: 'desempenho_por_equipe', value: 'Desempenho por equipe' },
        { key: 'saude_crianca', value: 'Saúde criança' },
        { key: 'vinculo_acompanhamento', value: 'Vínculo e Acompanhamento' },
      ],
      pagesCategoryEnfermeiroMedico: [
        { key: 'dashboard', value: 'Página inicial' },
        { key: 'gestao_cadastros', value: 'Gestão cadastros' },
        { key: 'imunizacao', value: 'Imunização' },
        { key: 'vacina_idade_certa', value: 'Vacina idade certa' },
        { key: 'divergencia_vacinas', value: 'Divergência vacinas' },
        { key: 'indicadores_aps', value: 'Indicadores APS' },
        { key: 'esf_eap', value: 'eSF / eAP' },
        { key: 'emulti', value: 'eMulti' },
        { key: 'saude_bucal', value: 'eSB' },
        { key: 'pre_natal', value: 'Pré-natal' },
        { key: 'doencas_cronicas', value: 'Doenças crônicas' },
        { key: 'desempenho_por_equipe', value: 'Desempenho por equipe' },
        { key: 'saude_crianca', value: 'Saúde criança' },
        { key: 'vinculo_acompanhamento', value: 'Vínculo e Acompanhamento' },
      ],
      pagesCategoryOdontologo: [
        { key: 'dashboard', value: 'Página inicial' },
        { key: 'gestao_cadastros', value: 'Gestão cadastros' },
        { key: 'indicadores_aps', value: 'Indicadores APS' },
        { key: 'esf_eap', value: 'eSF / eAP' },
        { key: 'emulti', value: 'eMulti' },
        { key: 'saude_bucal', value: 'eSB' },
        { key: 'pre_natal', value: 'Pré-natal' },
        { key: 'doencas_cronicas', value: 'Doenças crônicas' },
        { key: 'desempenho_por_equipe', value: 'Desempenho por equipe' },
        { key: 'vinculo_acompanhamento', value: 'Vínculo e Acompanhamento' },
      ],
      pagesCategoryRecepcionista: [
        { key: 'dashboard', value: 'Página inicial' },
        { key: 'gestao_cadastros', value: 'Gestão cadastros' },
        { key: 'indicadores_aps', value: 'Indicadores APS' },
        { key: 'esf_eap', value: 'eSF / eAP' },
        { key: 'emulti', value: 'eMulti' },
        { key: 'saude_bucal', value: 'eSB' },
        { key: 'pre_natal', value: 'Pré-natal' },
        { key: 'doencas_cronicas', value: 'Doenças crônicas' },
        { key: 'desempenho_por_equipe', value: 'Desempenho por equipe' },
        { key: 'vinculo_acompanhamento', value: 'Vínculo e Acompanhamento' },
      ],
      pagesCategoryCoordenador: [
        { key: 'dashboard', value: 'Página inicial' },
        { key: 'gestao_cadastros', value: 'Gestão cadastros' },
        { key: 'visitas_domiciliares', value: 'Visitas domiciliares' },
        { key: 'imunizacao', value: 'Imunização' },
        { key: 'vacina_idade_certa', value: 'Vacina idade certa' },
        { key: 'indicadores_aps', value: 'Indicadores APS' },
        { key: 'esf_eap', value: 'eSF / eAP' },
        { key: 'emulti', value: 'eMulti' },
        { key: 'saude_bucal', value: 'eSB' },
        { key: 'pre_natal', value: 'Pré-natal' },
        { key: 'doencas_cronicas', value: 'Doenças crônicas' },
        { key: 'desempenho_por_equipe', value: 'Desempenho por equipe' },
        { key: 'saude_crianca', value: 'Saúde criança' },
        { key: 'vinculo_acompanhamento', value: 'Vínculo e Acompanhamento' },
      ],
      pagesCategoryVacinador: [
        { key: 'dashboard', value: 'Página inicial' },
        { key: 'gestao_cadastros', value: 'Gestão cadastros' },
        { key: 'imunizacao', value: 'Imunização' },
        { key: 'vacina_idade_certa', value: 'Vacina idade certa' },
        { key: 'divergencia_vacinas', value: 'Divergência vacinas' },
        { key: 'indicadores_aps', value: 'Indicadores APS' },
        { key: 'esf_eap', value: 'eSF / eAP' },
        { key: 'emulti', value: 'eMulti' },
        { key: 'saude_bucal', value: 'eSB' },
      ],
      pagesCategoryTecSaudeBucal: [
        { key: 'dashboard', value: 'Página inicial' },
        { key: 'indicadores_aps', value: 'Indicadores APS' },
        { key: 'esf_eap', value: 'eSF / eAP' },
        { key: 'emulti', value: 'eMulti' },
        { key: 'saude_bucal', value: 'eSB' },
        { key: 'vinculo_acompanhamento', value: 'Vínculo e Acompanhamento' },
      ],
      loading: false,
      size: '40px',
      color: '#0D98BB',
    }
  },
  computed: {
    ...mapState(['id_funcao']),
  },
  mounted() {
    this.getPermissions()
  },
  methods: {
    async getPermissions() {
      try {
        this.loading = true
        const response = await this.$api.get(
          `/app/permissoes/${this.$store.state.cod_ibge}`
        )

        if (response && response.data) {
          const perfilConfigs = [
            {
              id: 3,
              pages: this.pagesCategoryAcs,
              model: 'permissoesAcs',
              dataModel: 'permissoesAcsData',
            },
            {
              id: 6,
              pages: this.pagesCategoryAuxEnfermagem,
              model: 'permissoesAuxEnfermagem',
              dataModel: 'permissoesAuxEnfermagemData',
            },
            {
              id: 4,
              pages: this.pagesCategoryEnfermeiroMedico,
              model: 'permissoesEnfermeiroMedico',
              dataModel: 'permissoesEnfermeiroMedicoData',
            },
            {
              id: 8,
              pages: this.pagesCategoryOdontologo,
              model: 'permissoesOdontologo',
              dataModel: 'permissoesOdontologoData',
            },
            {
              id: 5,
              pages: this.pagesCategoryRecepcionista,
              model: 'permissoesRecepcionista',
              dataModel: 'permissoesRecepcionistaData',
            },
            {
              id: 7,
              pages: this.pagesCategoryCoordenador,
              model: 'permissoesCoordenador',
              dataModel: 'permissoesCoordenadorData',
            },
            {
              id: 13,
              pages: this.pagesCategoryVacinador,
              model: 'permissoesVacinador',
              dataModel: 'permissoesVacinadorData',
            },
            {
              id: 14,
              pages: this.pagesCategoryTecSaudeBucal,
              model: 'permissoesTecSaudeBucal',
              dataModel: 'permissoesTecSaudeBucalData',
            },
          ]

          perfilConfigs.forEach(({ id, pages, model, dataModel }) => {
            const perfilData = response.data.filter((el) => el.id_perfil == id)
            pages.forEach((page) => {
              this.addCard(perfilData, id, model, dataModel, page.key)
            })
          })
        }
      } catch (error) {
        console.error('Erro ao buscar permissões:', error)
      } finally {
        this.loading = false
      }
    },

    addCard(
      permissoesApi,
      idPerfil,
      permissoesCheckbox,
      permissoesCards,
      permissionKey
    ) {
      // Object.filter = (obj, predicate) =>
      //   Object.keys(obj)
      //     .filter(key => predicate(obj[key]))
      //     .reduce((res, key) => ((res[key] = obj[key]), res), {})

      // const permissoesApiFormatada = Object.filter(
      //   permissoesApi[0],
      //   value => value == '1'
      // )

      const permissoesData = permissoes.find((el) => el.id_perfil === idPerfil)
      for (const key in permissoesApi[0]) {
        let val = permissoesData[permissionKey].find((el) => {
          return el.key === key
        })
        if (val !== undefined) {
          this[permissoesCards][permissionKey].push(val)

          if (permissoesApi[0][key] == '1') {
            this[permissoesCheckbox][permissionKey].push(val)
          }
        }
      }
    },

    async salvarPermissoes(idPerfil) {
      try {
        this.loading = true
        let payload = ''
        let pagesDisabled = []
        let nomePerfil = ''
        switch (idPerfil) {
          case 3:
            payload = this.formatPayload(
              this.permissoesAcs,
              this.permissoesAcsData
            )
            nomePerfil = 'Agente Comunitário de Saúde'
            break
          case 4:
            payload = this.formatPayload(
              this.permissoesEnfermeiroMedico,
              this.permissoesEnfermeiroMedicoData
            )
            nomePerfil = 'Enfermeiro(a) / Médico(a)'
            break
          case 6:
            payload = this.formatPayload(
              this.permissoesAuxEnfermagem,
              this.permissoesAuxEnfermagemData
            )
            nomePerfil = 'Aux/Téc Enfermagem'
            break
          case 8:
            payload = this.formatPayload(
              this.permissoesOdontologo,
              this.permissoesOdontologoData
            )
            nomePerfil = 'Odontólogo(a)'
            break
          case 5:
            payload = this.formatPayload(
              this.permissoesRecepcionista,
              this.permissoesRecepcionistaData
            )
            nomePerfil = 'Recepcionista'
            break
          case 7:
            payload = this.formatPayload(
              this.permissoesCoordenador,
              this.permissoesCoordenadorData
            )
            nomePerfil = 'Gerente/Coordenador(a)'
            break
          case 13:
            payload = this.formatPayload(
              this.permissoesVacinador,
              this.permissoesVacinadorData
            )
            nomePerfil = 'Vacinador(a)'
            break
          case 14:
            payload = this.formatPayload(
              this.permissoesTecSaudeBucal,
              this.permissoesTecSaudeBucalData
            )
            nomePerfil = 'Téc. Aux de Saúde Bucal'
            break
          default:
            break
        }

        const response = await this.$api.post(
          '/app/permissoes/' + this.$store.state.cod_ibge + '/' + idPerfil,
          {
            payload: {
              ...payload,
            },
          }
        )
        if (response) {
          if (response.data.error == false) {
            this.$toast.success(
              `Permissões para o perfil: ${nomePerfil} alteradas com sucesso!`,
              'Sucesso:',
              {
                position: 'topRight',
              }
            )
          } else {
            this.$toast.error(response.data.message, 'Error:', {
              position: 'topRight',
            })
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    formatPayload(permissoesEnable, permissoesData) {
      let permissoesDisabled = []
      if (!this.deepEqual(permissoesEnable, permissoesData)) {
        for (const key in permissoesEnable) {
          let difference = permissoesEnable[key]
            .filter((x) => !permissoesData[key].includes(x))
            .concat(
              permissoesData[key].filter(
                (x) => !permissoesEnable[key].includes(x)
              )
            )
          if (difference.length > 0) {
            permissoesDisabled.push(...difference)
          }
        }
      }

      return {
        enable: JSON.stringify(permissoesEnable),
        disable: JSON.stringify(permissoesDisabled),
      }
    },
  },
}
</script>

<style></style>
